import React from "react";
import { Stack, TextField } from "@mui/material";
import { formatLiteral, parseLiteral } from "./constants";
import type { OperandTypeComponentProps } from "./types";

export const LiteralOperand: React.FC<OperandTypeComponentProps> = ({ value, onChange }) => (
    <Stack spacing={1}>
        <TextField
            size="small"
            label="Value"
            value={formatLiteral(value?.value)}
            onChange={(e) => onChange({ value: parseLiteral(e.target.value) })}
            fullWidth
        />
    </Stack>
);
